<template>
  <div class="qrcode-counter">
    <van-nav-bar
      :title="$route.meta.title"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    />
    <div class="image">
      <img class="img-cell-l" fit="cover" :src="imgData" />
    </div>
    <div class="text-explain">请将二维码对准扫描设备完成消费</div>
    <div class="refresh-btn" @click="handleRefresh">手动刷新二维码</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgData: "",
      timer: null,
      customerId: '',
      payCode: ''
    };
  },
  async mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    await this.getPayId();
    this.$nextTick(() => {
      this.getPayCodeload();
    });
    this.timer = setInterval(() => {
      this.getPayCodeload();
    }, 1000 * 60 * 2);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取cardId
    async getPayId() {
      const { data: res } = await this.$authAjax.get(`/api/wxapp/paycard/list/${this.customerId}`)
      if(res.code == 200) {
        this.payCode = res.data[0].payCards[0].id
      } else {
        this.$toast(res.message)
      }
    },

    getPayCodeload() {
      this.$authAjax
        .get(`/api/wxapp/cardimg/${this.payCode}`)
        .then((res) => {
          if (res.data.code == 200) {
            this.imgData = `data:image/jpeg;base64,${res.data.data}`;
          } else {
            this.$toast(res.data.message);
          }
        });
    },

    handleRefresh() {
      this.getPayCodeload();
    }
  },
};
</script>

<style lang="scss" scoped>
.qrcode-counter {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  padding: 16px;
  box-sizing: border-box;
  overflow: auto;
  ::v-deep {
    .van-nav-bar {
      background: #63a4e1;
    }
    .van-nav-bar__title {
      color: #ffffff;
    }
    .van-icon-arrow-left {
      color: #ffffff;
    }
  }
  .image {
    width: 200px;
    height: 200px;
    margin: 85px auto;
    .img-cell-l {
      width: 200px;
      height: 200px;
    }
  }

  .text-explain {
    text-align: center;
    color: #999999;
    font-size: 14px;
    margin-top: 10px;
  }
  .refresh-btn {
    width: 343px;
    height: 45px;
    background: #63a4e1;
    border-radius: 8px;
    text-align: center;
    line-height: 45px;
    color: #ffffff;
    font-size: 16px;
    margin: 20px auto;
  }
}
</style>